module.exports = __webpack_public_path__ + "static/media/IMG_1062.985647b4.jpg";